module.exports = __webpack_public_path__ + "img/no_2.23fb5761.png";